/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Payment_Method_Change_Blocked_TitleInputs */

const vi_order_payment_method_change_blocked_title = /** @type {(inputs: Order_Payment_Method_Change_Blocked_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không đổi được hình thức`)
};

/**

* @param {Order_Payment_Method_Change_Blocked_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_payment_method_change_blocked_title = /** @type {((inputs?: Order_Payment_Method_Change_Blocked_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Payment_Method_Change_Blocked_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_payment_method_change_blocked_title(inputs)
});